// removed by extract-text-webpack-plugin
module.exports = {"fixedVoice":"styles__fixedVoice___3kJ0N","containerSale":"styles__containerSale___1eA3U","columnNewSale":"styles__columnNewSale___2ayY7","columnsResume":"styles__columnsResume___1tlc0","content":"styles__content___3p_Tb","modal_container":"styles__modal_container___lXtfk","error":"styles__error___1JkDu","button_container":"styles__button_container___34ODq"};


//////////////////
// WEBPACK FOOTER
// ./src/scenes/FixedVoice/Pages/NewSale/styles.css
// module id = 3233
// module chunks = 0